import React, { useState, useEffect } from "react";
import { Dropdown, Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { 
  ProgramDropdown,
  BrandDropdown,
  BussinesModelDropdown,
  GeographiesDropdown,
  LanguagesDropdown
} from "CommonDropdowns";
import moment from 'moment-timezone';

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
  // Dropdown state removed
  const [programValue, setProgramValue] = useState(null);
  const [brandValue, setBrandValue] = useState(null);
  const [languageValue, setLanguageValue] = useState(null);
  const [businessModelValue, setBusinessModelValue] = useState(null);
  const [geographyValue, setGeographyValue] = useState(null);
  
  const handleToggle = (isOpen) => {
  // Removed: setShow
  };

  const handleSearch = () => {
  onFilter();
  };

  const handleReset = () => {
    setExtraFiltersState({
      ...extraFiltersState,
      values: {
        year: "",
        month: "",
        program_id: null,
        brand_id: null,
        language_id: null,
        business_model_id: null,
        geography_id: null,
        selectedDate: null,
        formatDate: "",
      },
    });
    setProgramValue(null);
    setBrandValue(null);
    setLanguageValue(null);
    setBusinessModelValue(null);
    setGeographyValue(null);
    onFilter();
    // Removed: setShow
  };

  const handleInputChange = (name, value) => {
    setExtraFiltersState((extraFiltersState) => ({
      ...extraFiltersState,
      values: {
        ...extraFiltersState.values,
        [name]: value,
      },
    }));
  };

  const handleDateChange = (date) => {  
    if (!date) {
      setExtraFiltersState((extraFiltersState) => ({
        ...extraFiltersState,
        values: {
          ...extraFiltersState.values,
          year: "",
          month: "",
          program_id: null,
          brand_id: null,
          language_id: null,
          business_model_id: null,
          geography_id: null,
          selectedDate: null,
          formatDate: "",
        },
      }));
      setProgramValue(null);
      setBrandValue(null);
      setLanguageValue(null);
      setBusinessModelValue(null);
      setGeographyValue(null);
    } else {
      let formatDate = moment(date).format("YYYY-MM");
      setExtraFiltersState((extraFiltersState) => ({
        ...extraFiltersState,
        values: {
          ...extraFiltersState.values,
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          formatDate: formatDate,
          selectedDate: date,
        },
      }));
    }
  };

  const handleProgramChange = (selected) => {
    setProgramValue(selected);
    const programId = selected ? selected.value : null;
    
    handleInputChange("program_id", programId); 
    // Reset brand when program changes
    setBrandValue(null);
    handleInputChange("brand_id", null);
  };

  const handleBrandChange = (selected) => {
    setBrandValue(selected);
    const brandId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("brand_id", brandId);
  };

  const handleLanguageChange = (selected) => {
    setLanguageValue(selected);
    const languageId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("language_id", languageId);
  };

  const handleBusinessModelChange = (selected) => {
    setBusinessModelValue(selected);
    const businessModelId = selected
      ? selected.map((item) => item.value)
      : null;
    handleInputChange("business_model_id", businessModelId);
  };

  const handleGeographyChange = (selected) => {
    setGeographyValue(selected);
    const geographyId = selected ? selected.map((item) => item.value) : null;
    handleInputChange("geography_id", geographyId);
  };

  return (
    <section className="filters-flex">
      <Form>
        <Row className="align-items-end" style={{ gap: '16px', flexWrap: 'nowrap' }}>
          <Col>
            <Form.Group className="mb-3">
              <Form.Label className="label-input">Period</Form.Label>
              <DatePicker
                selected={extraFiltersState.values.selectedDate}
                onChange={handleDateChange}
                dateFormat="yyyy-MM"
                showMonthYearPicker
                className="input-field form-control"
                placeholderText="Choose Period"
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <ProgramDropdown
                programValue={programValue}
                setProgramValue={setProgramValue}
                isMulti={false}
                selectedId={extraFiltersState.values.program_id}
                programOnChange={handleProgramChange}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <BrandDropdown
                value={brandValue}
                setValue={setBrandValue}
                onChange={handleBrandChange}
                isMulti={true}
                program_id={extraFiltersState.values.program_id}
                selectedId={extraFiltersState.values.brand_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <LanguagesDropdown
                value={languageValue}
                setValue={setLanguageValue}
                onChange={handleLanguageChange}
                isMulti={true}
                selectedId={extraFiltersState.values.language_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <BussinesModelDropdown
                value={businessModelValue}
                setValue={setBusinessModelValue}
                onChange={handleBusinessModelChange}
                isMulti={true}
                selectedId={extraFiltersState.values.business_model_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <Form.Group>
              <GeographiesDropdown
                value={geographyValue}
                setValue={setGeographyValue}
                onChange={handleGeographyChange}
                isMulti={true}
                selectedId={extraFiltersState.values.geography_id}
              />
            </Form.Group>
          </Col>
          <Col>
            <button
              type="button"
              onClick={handleSearch}
              className="add-new-btn w-100 mb-3"
            >
              <img
                src="/assets/images/search-white.svg"
                alt=""
                className="me-2"
              />{' '}
              Search
            </button>
          </Col>
        </Row>
      </Form>
    </section>
  );
};

export default Filter;
